
import { Component, Vue } from "vue-property-decorator";
import BusquedaTramites from "@/components/Tramites/BusquedaTramites.vue";

@Component({
  components: {
    BusquedaTramites
  }
})
export default class BusquedaTramitesView extends Vue {}
